import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

const KEY = "gesil_theme";

function getInitial() {
  try {
    return localStorage.getItem(KEY) || "light";
  } catch {
    return "light";
  }
}

function apply(t) {
  document.documentElement.classList.toggle("dark", t === "dark");
  try { localStorage.setItem(KEY, t); } catch { /* ignore */ }
}

export default function ThemeToggle({ compact = false }) {
  const [theme, setTheme] = useState(getInitial);

  useEffect(() => { apply(theme); }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));
  const dark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={dark ? "Switch to light theme" : "Switch to dark theme"}
      title={dark ? "Switch to light theme" : "Switch to dark theme"}
      className={`relative inline-flex items-center justify-center rounded-full border transition-all ${
        compact ? "h-9 w-9" : "h-10 w-10"
      } ${
        dark
          ? "bg-[#0B1B40] border-blue-700 text-amber-300 hover:bg-[#102554]"
          : "bg-white border-blue-200 text-[#1D4ED8] hover:border-[#2563EB] hover:bg-blue-50"
      }`}
    >
      {dark ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
}
